export default [
  {
    path: '/main/dashboard',
    name: 'main.dashboard',
    component: () => import('@/pages/main/dashboard-page'),
    props: () => ({ menu: 'dashboard' }),
    meta: {
      auth: true,
      viewName: 'Bảng điều khiển',
    },
  },
  // {
  //   path: '/main/invoice-setting',
  //   name: 'main.invoice-setting',
  //   component: () => import('@/pages/main/invoice-setting'),
  //   props: () => ({ menu: 'invoice-setting' }),
  //   meta: {
  //     auth: true,
  //     viewName: 'Cấu hình hóa đơn',
  //   },
  // },
  {
    path: '/main/revenue',
    name: 'main.revenue',
    component: () => import('@/pages/main/issued/revenue-invoices-page'),
    props: () => ({ menu: 'revenue' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn doanh thu',
    },
  },
  {
    path: '/main/expense',
    name: 'main.expense',
    component: () => import('@/pages/main/issued/expense-invoices-page'),
    props: () => ({ menu: 'expense' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn chi phí',
    },
  },
  {
    path: '/main/payment-receipt',
    name: 'main.payment-receipt',
    component: () => import('@/pages/main/issued/payment-receipts-page'),
    props: () => ({ menu: 'payment-receipt' }),
    meta: {
      auth: true,
      viewName: 'Biên nhận thanh toán',
    },
  },
  {
    path: '/main/suspect',
    name: 'main.suspect',
    component: () => import('@/pages/main/issued/suspected-invoices-page'),
    props: () => ({ menu: 'suspect' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn nghi ngờ',
    },
  },
  {
    path: '/main/inconsistency',
    name: 'main.inconsistency',
    component: () => import('@/pages/main/issued/inconsistency-invoices-page'),
    props: () => ({ menu: 'inconsistency' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn không nhất quán',
    },
  },
  {
    path: '/main/payable-debt',
    name: 'main.payable-debt',
    component: () => import('@/pages/main/issued/payable-debt-invoices-page'),
    props: () => ({ menu: 'payable-debt' }),
    meta: {
      auth: true,
      viewName: 'Công nợ phải trả',
    },
  },
  {
    path: '/main/receivable-debt',
    name: 'main.receivable-debt',
    component: () => import('@/pages/main/issued/receivable-debt-invoices-page'),
    props: () => ({ menu: 'receivable-debt' }),
    meta: {
      auth: true,
      viewName: 'Công nợ phải thu',
    },
  },
  {
    path: '/main/all',
    name: 'main.all',
    component: () => import('@/pages/main/issued/all-invoices-page'),
    props: () => ({ menu: 'ALL' }),
    meta: {
      auth: true,
      viewName: 'Tất cả hóa đơn',
    },
  },
  {
    path: '/main/tag/:tag',
    name: 'main.tag',
    component: () => import('@/pages/main/issued/tag-based-invoices-page'),
    props: route => ({ tag: route.params.tag }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn theo thẻ',
    },
  },
  {
    path: '/main/status/dashboard',
    name: 'main.status.dashboard',
    component: () => import('@/pages/main/status-dashboard-page'),
    props: () => ({ menu: 'status-dashboard' }),
    meta: {
      auth: true,
      viewName: 'Bảng điều khiển trạng thái hóa đơn',
    },
  },
  {
    path: '/main/product-management',
    name: 'main.product-management',
    component: () => import('@/pages/main/product-management-page'),
    props: () => ({ menu: 'product-management' }),
    meta: {
      auth: true,
      viewName: 'Quản lý sản phẩm',
    },
  },
  {
    path: '/main/status/draft',
    name: 'main.status.draft',
    component: () => import('@/pages/main/issuing/draft-invoices-page'),
    props: () => ({ menu: 'draft' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn nháp',
    },
  },
  {
    path: '/main/status/failed',
    name: 'main.status.failed',
    component: () => import('@/pages/main/issuing/failed-invoices-page'),
    props: () => ({ menu: 'failed' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn xuất thất bại',
    },
  },
  {
    path: '/main/status/issuing',
    name: 'main.status.issuing',
    component: () => import('@/pages/main/issuing/issuing-invoices-page'),
    props: () => ({ menu: 'issuing' }),
    meta: {
      auth: true,
      viewName: 'Hóa đơn đang phát hành',
    },
  },
  {
    path: '/customer/:id?/:invoiceType?',
    name: 'customer',
    component: () => import('@/pages/customer-page'),
    props: route => ({ invoiceType: route.params.invoiceType || 'ALL', id: route.params.id || 'none' }),
    meta: {
      auth: true,
      viewName: 'Khách hàng',
    },
  },
  {
    path: '/vendor/:id?/:invoiceType?',
    name: 'vendor',
    component: () => import('@/pages/vendor-page'),
    props: route => ({ invoiceType: route.params.invoiceType || 'ALL', id: route.params.id || 'none' }),
    meta: {
      auth: true,
      viewName: 'Nhà cung cấp',
    },
  },
  { path: '/', redirect: '/main/approved' },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login-page'),
    meta: {
      guest: true,
      layout: 'empty',
      viewName: 'Đăng nhập',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/register-page'),
    meta: {
      guest: true,
      layout: 'empty',
      viewName: 'Đăng ký',
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import('@/pages/forgot-page'),
    meta: {
      guest: true,
      layout: 'empty',
      viewName: 'Quên mật khẩu',
    },
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('@/pages/reset-page'),
    meta: {
      guest: true,
      layout: 'empty',
      viewName: 'Cài lại mật khẩu',
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/pages/notification-page'),
    meta: {
      auth: true,
      viewName: 'Thông báo',
    },
  },
  { path: '*', redirect: '/main/dashboard' },
];



// WEBPACK FOOTER //
// ./src/routes/routes.js